import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { App } from './App.tsx';
import './styles/app.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

// A data router (one catch-all route; the app's own <Routes> do the rest) so
// a page can stop a person leaving with unsaved changes (useBlocker needs it).
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
